export var environment = {
    apiUrl: 'https://uygulama.bagcilar.bel.tr/api/',
    //apiUrl: 'http://localhost:5000/api/',
    appName: 'Uygulamalar'
}


// WEBPACK FOOTER //
// ./src/environments/environment.ts